export default __webpack_public_path__ + "static/media/dopes4.42147b3f.jfif";